/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/
// Groups the GitLab family ("gitlab", "eclipse-gitlab", ...) so icons and field help can be shared.
export const providerKind = (providerId) => providerId === 'github' ? 'github' : providerId.includes('gitlab') ? 'gitlab' : 'generic';
// The server serves registration inputs unordered; impose a stable order.
const REGISTRATION_KEY_ORDER = ['owner', 'repo', 'namespace', 'project', 'workflow', 'environment'];
export const orderRegistrationKeys = (keys) => {
    const rank = (key) => {
        const index = REGISTRATION_KEY_ORDER.indexOf(key);
        return index === -1 ? Number.MAX_SAFE_INTEGER : index;
    };
    return [...keys].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
};
const REGISTRATION_PATH_PAIRS = [
    ['owner', 'repo'],
    ['namespace', 'project']
];
export const findRegistrationPathPair = (keys) => {
    const present = new Set(keys);
    return REGISTRATION_PATH_PAIRS.find(pair => pair.every(key => present.has(key)));
};
//# sourceMappingURL=registration-fields.js.map